<!-- AdditionalExpenses.vue -->
<template>
  <div>
    -
    {{
      $t("compensation.additional2", {
        amount: amount,
        expenseType: expenseType,
      })
    }}
    <span v-if="customerData.length > 1">{{
      $t("compensation.additional3")
    }}</span>
  </div>
</template>

<script>
export default {
  props: ["amount", "expenseType"],
};
</script>
